import type { NomineeRelationship } from '@/api/type/policy';
import type { Policy } from '@/types';
import { MONTHLY_FEE, PLAN_MONTHS } from '@/lib/payments';
import { addMonthsToKey } from '@/lib/months';

/** Savings interest paid on the policy amount: 6% per year, added monthly. */
export const SAVINGS_RATE = 0.06;

export const POLICY_PLAN_AMOUNT = PLAN_MONTHS * MONTHLY_FEE;

export const NOMINEE_RELATIONSHIP_OPTIONS: NomineeRelationship[] = [
  'Father',
  'Mother',
  'Spouse',
  'Son',
  'Daughter',
  'Brother',
  'Sister',
  'Other',
];

export const getPolicyEndMonth = (startMonth: string): string =>
  addMonthsToKey(startMonth, PLAN_MONTHS - 1);

export const getPolicyProgress = (policy: Pick<Policy, 'paidMonths' | 'totalMonths'>) => {
  const totalMonths = policy.totalMonths || PLAN_MONTHS;
  const paidAmount = policy.paidMonths * MONTHLY_FEE;
  const totalAmount = totalMonths * MONTHLY_FEE;

  return {
    percent: Math.min(100, Math.round((policy.paidMonths / totalMonths) * 100)),
    paidAmount,
    totalAmount,
    leftAmount: Math.max(0, totalAmount - paidAmount),
  };
};

const isPolicyClosed = (policy: Pick<Policy, 'status'>): boolean => policy.status === 'closed';

/** Policy payments are allowed while the policy is open and has months left. */
export const canPayPolicy = (policy: Pick<Policy, 'status' | 'paidMonths' | 'totalMonths'>): boolean =>
  !isPolicyClosed(policy) && policy.paidMonths < (policy.totalMonths || PLAN_MONTHS);
